window.__ = {
  SYMBOLS: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789',

  SHOUT_SIZE_RATIO: 1150,

  generateID(length) {
    let id = '';

    for (let i = 0; i < length; i++) {
      id += this.SYMBOLS.charAt(Math.floor(Math.random() * this.SYMBOLS.length));
    }

    return id;
  },

  getShoutFontSize() {
    const book = window.application.book;
    const viewArea = book.viewWidth * book.viewHeight;

    const fontSize = Math.sqrt(viewArea / this.SHOUT_SIZE_RATIO) | 0;

    return fontSize;
  },

  imageSrcToVariations({ src, type }) {
    const mobileSrc = (src || '').replace(/\.(jpg|png)/, '--mobile.$1')
    const typeVar = `--${type}Src`
    const mobileTypeVar = `--mobile${type.substr(0, 1).toUpperCase() + type.substr(1)}Src`

    return `${typeVar}: url(${src}); ${mobileTypeVar}: url(${mobileSrc})`
  },
}
